import React, { useEffect, useState } from "react";
import classes from "../Management.module.scss";
import styles from "./DealerPipeline.module.scss";
import { searchDealerAdminCustomerRecords } from "../../../services/dealerGarage";
import { formatPhone, sinceLabel } from "./dealerAdmin";

const KIND_LABELS = { account: "Account", "guest-account": "Guest account", lead: "Lead only" };

/**
 * The Customers list: everyone with an account plus guests who only ever sent
 * a lead, searched by name, email or phone (every word must match). With
 * nothing typed, the customers behind the most recently updated leads,
 * inspections and purchases.
 *
 * Props: onOpen(ref) - opens the customer panel
 */
const CustomersSection = ({ onOpen }) => {
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState(null);
  const [recent, setRecent] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let live = true;
    const timer = setTimeout(() => {
      setLoading(true);
      searchDealerAdminCustomerRecords(search.trim(), 25)
        .then((res) => {
          if (!live) return;
          setRows(Array.isArray(res && res.data) ? res.data : []);
          setRecent(!!(res && res.recent));
        })
        .catch(() => { if (live) setRows([]); })
        .finally(() => { if (live) setLoading(false); });
    }, search.trim() ? 250 : 0);
    return () => {
      live = false;
      clearTimeout(timer);
    };
  }, [search]);

  return (
    <div>
      <input
        className={classes.search_users}
        placeholder="Search customers by name, email or phone"
        aria-label="Search customers"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      <p className={styles.hint}>{recent ? "Recently active customers." : "Accounts and guest leads matching every word."}</p>
      <div className={`${classes.tableContainer} ${styles.scrollTable}`}>
        <table className={classes.table}>
          <thead>
            <tr className={classes.tableHeaderRow}>
              <th className={classes.tableHead}>Customer</th>
              <th className={classes.tableHead}>Phone</th>
              <th className={classes.tableHead}>Type</th>
              {recent && <th className={classes.tableHead}>Last activity</th>}
              <th className={classes.tableHead}></th>
            </tr>
          </thead>
          <tbody>
            {rows === null && (
              <tr className={classes.tableRow}><td className={classes.tableData} colSpan={5}>Loading...</td></tr>
            )}
            {rows && rows.length === 0 && !loading && (
              <tr className={classes.tableRow}><td className={classes.tableData} colSpan={5}>No customers match.</td></tr>
            )}
            {(rows || []).map((row) => (
              <tr key={JSON.stringify(row.ref)} className={classes.tableRow}>
                <td className={classes.tableData}>
                  <button type="button" className={`${classes.clickableCell} ${styles.linkButton}`} onClick={() => onOpen(row.ref)}>
                    {row.name || row.email}
                  </button>
                  {row.name && <><br /><small>{row.email}</small></>}
                </td>
                <td className={classes.tableData}>{row.phone ? formatPhone(row.phone) : "-"}</td>
                <td className={classes.tableData}>{KIND_LABELS[row.kind] || row.kind}</td>
                {recent && <td className={classes.tableData}>{sinceLabel(row.lastActivityAt)}</td>}
                <td className={classes.tableData}>
                  <button type="button" className={classes.tableButton} onClick={() => onOpen(row.ref)}>Open</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CustomersSection;
